import React, { useEffect, useState } from 'react';
import './tableTransaction.css';
import { getProjectCostDropdown } from '../axios/MenuDropdownAxios';

export default function PCJournalsTable({ groupId, journals, setJournals }) {
  const [dropdownProjectCost, setDropdownProjectCost] = useState([]);
  const [loadingDropdown, setLoadingDropdown] = useState(false);

  const fetchDropdownProjectCost = async () => {
    try {
      setLoadingDropdown(true);
      const data = await getProjectCostDropdown(); // Panggil fungsi Axios
      setDropdownProjectCost(data);
    } catch (error) {
      console.error('Error fetching dropdown data project cost', error);
    } finally {
      setLoadingDropdown(false);
    }
  };

  useEffect(() => {
    fetchDropdownProjectCost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatNumber = (value) => {
    if (!value) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const unformatNumber = (value) => {
    return value ? value.toString().replace(/,/g, '') : '';
  };

  const handleChange = (index, field, value) => {
    const updated = [...journals];

    let cleanedValue = value;
    if (['unit_price', 'qty', 'duration'].includes(field)) {
      cleanedValue = unformatNumber(value);
      if (!/^\d*$/.test(cleanedValue)) return;
    }

    updated[index][field] = cleanedValue;

    // Hitung total
    const price = parseInt(unformatNumber(updated[index].unit_price)) || 0;
    const qty = parseInt(updated[index].qty) || 0;
    const dur = parseInt(updated[index].duration) || 0;
    updated[index].total = price * qty * dur;

    setJournals(updated);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const formElements = Array.from(e.target.form.elements);
      const index = formElements.indexOf(e.target);
      formElements[index + 1]?.focus();
    }
  };

  const addRow = () => {
    setJournals([
      ...journals,
      {
        prjCost_code: '',
        unit: '',
        unit_price: '',
        qty: '',
        duration: '',
        total: '',
        description: '',
      },
    ]);
  };

  const removeRow = (index) => {
    setJournals(journals.filter((_, i) => i !== index));
  };

  const subtotal = journals.reduce(
    (sum, row) => sum + (parseInt(row.total) || 0),
    0
  );

  return (
    <div>
      {/* <h6>{groupId}</h6> */}
      <button
        className="btn btn-primary btn-sm mb-3"
        onClick={addRow}
        type="button"
      >
        + Add Row
      </button>

      <div className="table-responsive">
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              <th>Cost Code</th> {/* Memberi lebar 25% */}
              <th>Unit</th>
              <th>Unit Price</th>
              <th>Qty</th>
              <th>Duration</th>
              <th>Total</th>
              <th>Description</th> {/* Memberi lebar 23% */}
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {journals.length === 0 && (
              <tr>
                <td colSpan="8" className="text-center text-muted">
                  No journal data. Click "Add Row".
                </td>
              </tr>
            )}

            {journals.map((row, index) => (
              <tr key={index}>
                <td>
                  <select
                    className="form-control form-control-sm"
                    value={row.prjCost_code}
                    disabled={loadingDropdown}
                    title={
                      dropdownProjectCost.find(
                        (option) => option.value === row.prjCost_code
                      )?.label || ''
                    }
                    onChange={(e) =>
                      handleChange(index, 'prjCost_code', e.target.value)
                    }
                  >
                    {loadingDropdown && (
                      <option value="" disabled>
                        Loading cost codes...
                      </option>
                    )}
                    <option value="">-- Select Cost Code --</option>

                    {!loadingDropdown &&
                      dropdownProjectCost
                        .filter((item) => item.value.startsWith(groupId))
                        .map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                  </select>
                </td>

                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={row.unit}
                    title={row.unit}
                    onChange={(e) =>
                      handleChange(index, 'unit', e.target.value)
                    }
                    onKeyDown={handleKeyDown}
                  />
                </td>

                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm text-end"
                    value={formatNumber(row.unit_price)}
                    title={formatNumber(row.unit_price)}
                    onChange={(e) =>
                      handleChange(index, 'unit_price', e.target.value)
                    }
                    onKeyDown={handleKeyDown}
                  />
                </td>

                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm text-end"
                    value={row.qty}
                    title={row.qty}
                    onChange={(e) => handleChange(index, 'qty', e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                </td>

                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm text-end"
                    value={row.duration}
                    title={row.duration}
                    onChange={(e) =>
                      handleChange(index, 'duration', e.target.value)
                    }
                    onKeyDown={handleKeyDown}
                  />
                </td>

                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm text-end bg-light"
                    value={formatNumber(row.total)}
                    disabled
                  />
                </td>

                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={row.description}
                    title={row.description}
                    onChange={(e) =>
                      handleChange(index, 'description', e.target.value)
                    }
                    onKeyDown={handleKeyDown}
                  />
                </td>

                <td className="text-center">
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => removeRow(index)}
                    type="button"
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            ))}

            {journals.length > 0 && (
              <tr className="table-secondary fw-bold">
                <td colSpan="5" className="text-end">
                  Subtotal
                </td>
                <td className="text-end">{formatNumber(subtotal)}</td>
                <td colSpan="2"></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
